// src/components/HeroHeader.tsx
import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import moment from "moment";
import { HeroHeaderProps } from "../Types/types";

const HeroHeader: React.FC<HeroHeaderProps> = ({ title, timestamp }) => {
  // parse timestamp as UTC, then convert to local
  const m = moment.utc(timestamp).local();
  const formatted = m.format("LLL");      // e.g. “May 27, 2025  2:34 PM”
  const fromNow = m.fromNow();          // e.g. “2 hours ago”

  return (
    <div className="p-4 mb-5 rounded sticky-top hero-header">
      <Row className="align-items-center">
        <Col xs="auto">
          <Badge bg="primary" className="p-3 fs-3 rounded-circle">
            {title.charAt(0)}
          </Badge>
        </Col>
        <Col>
          <h1 className="mb-1">{title}</h1>
          <div className="text-muted">
            Generated <strong>{formatted}</strong> (<em>{fromNow}</em>)
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default HeroHeader;
